/**
 * Copy for the Rizful pitch shown at the bottom of the public utility pages.
 */

export interface RizfulPitchStrings {
  free: string; // badge text, e.g. "FREE"
  headline: string;
  subhead: string;
  features: string[];
  cta: string;
}

const en: RizfulPitchStrings = {
  free: "FREE",
  headline: "Rizful is your free Lightning homebase",
  subhead: "No install, no subscription, no fees to receive.",
  features: [
    "Your own @rizful.com Lightning Address",
    "Receive Bitcoin payments",
    "Payments settle in about a second",
    "Connect hundreds of apps with NWC",
    "Works in any browser, phone or desktop",
  ],
  cta: "Get your free Lightning Address",
};

const es: RizfulPitchStrings = {
  free: "GRATIS",
  headline: "Rizful es tu base Lightning gratuita",
  subhead: "Sin instalación, sin suscripción, sin comisiones por recibir.",
  features: [
    "Tu propia Lightning Address @rizful.com",
    "Recibe pagos en Bitcoin",
    "Los pagos se liquidan en un segundo",
    "Conecta cientos de apps con NWC",
    "Funciona en cualquier navegador, móvil o PC",
  ],
  cta: "Obtén tu Lightning Address gratis",
};

const pt: RizfulPitchStrings = {
  free: "GRÁTIS",
  headline: "Rizful é a sua base Lightning gratuita",
  subhead: "Sem instalação, sem assinatura, sem taxas para receber.",
  features: [
    "Seu próprio Lightning Address @rizful.com",
    "Receba pagamentos em Bitcoin",
    "Pagamentos liquidados em cerca de um segundo",
    "Conecte centenas de apps com NWC",
    "Funciona em qualquer navegador, celular ou computador",
  ],
  cta: "Pegue seu Lightning Address grátis",
};

const fr: RizfulPitchStrings = {
  free: "GRATUIT",
  headline: "Rizful est votre base Lightning gratuite",
  subhead: "Sans installation, sans abonnement, sans frais de réception.",
  features: [
    "Votre propre Lightning Address @rizful.com",
    "Recevez des paiements en Bitcoin",
    "Paiements réglés en une seconde environ",
    "Connectez des centaines d'apps avec NWC",
    "Fonctionne dans tout navigateur, mobile ou ordinateur",
  ],
  cta: "Obtenez votre Lightning Address gratuite",
};

const de: RizfulPitchStrings = {
  free: "KOSTENLOS",
  headline: "Rizful ist deine kostenlose Lightning-Basis",
  subhead: "Keine Installation, kein Abo, keine Gebühren beim Empfangen.",
  features: [
    "Deine eigene @rizful.com Lightning-Adresse",
    "Bitcoin-Zahlungen empfangen",
    "Zahlungen in etwa einer Sekunde abgewickelt",
    "Hunderte Apps per NWC verbinden",
    "Läuft in jedem Browser, auf Handy oder Desktop",
  ],
  cta: "Hol dir deine kostenlose Lightning-Adresse",
};

const it: RizfulPitchStrings = {
  free: "GRATIS",
  headline: "Rizful è la tua base Lightning gratuita",
  subhead: "Nessuna installazione, nessun abbonamento, nessuna commissione in ricezione.",
  features: [
    "Il tuo Lightning Address @rizful.com",
    "Ricevi pagamenti in Bitcoin",
    "Pagamenti regolati in circa un secondo",
    "Collega centinaia di app con NWC",
    "Funziona in qualsiasi browser, su telefono o computer",
  ],
  cta: "Ottieni il tuo Lightning Address gratis",
};

const nl: RizfulPitchStrings = {
  free: "GRATIS",
  headline: "Rizful is je gratis Lightning-thuisbasis",
  subhead: "Geen installatie, geen abonnement, geen kosten om te ontvangen.",
  features: [
    "Je eigen @rizful.com Lightning-adres",
    "Ontvang Bitcoin-betalingen",
    "Betalingen in ongeveer een seconde afgerond",
    "Koppel honderden apps via NWC",
    "Werkt in elke browser, op telefoon of computer",
  ],
  cta: "Krijg je gratis Lightning-adres",
};

const ja: RizfulPitchStrings = {
  free: "無料",
  headline: "Rizfulは無料のライトニング拠点です",
  subhead: "インストール不要、サブスク不要、受け取り手数料なし。",
  features: [
    "あなた専用の @rizful.com ライトニングアドレス",
    "ビットコイン決済の受け取り",
    "決済は約1秒で完了",
    "NWCで数百のアプリと連携",
    "スマホでもPCでも、どのブラウザでも使える",
  ],
  cta: "無料のライトニングアドレスを取得",
};

const zh: RizfulPitchStrings = {
  free: "免费",
  headline: "Rizful 是您免费的闪电网络大本营",
  subhead: "无需安装，无需订阅，收款零手续费。",
  features: [
    "专属 @rizful.com 闪电地址",
    "接收比特币付款",
    "付款约一秒到账",
    "通过 NWC 连接数百款应用",
    "手机或电脑，任何浏览器都能用",
  ],
  cta: "免费获取闪电地址",
};

const ko: RizfulPitchStrings = {
  free: "무료",
  headline: "Rizful은 무료 라이트닝 홈베이스입니다",
  subhead: "설치 없음, 구독 없음, 받을 때 수수료 없음.",
  features: [
    "나만의 @rizful.com 라이트닝 주소",
    "비트코인 결제 받기",
    "약 1초 만에 결제 완료",
    "NWC로 수백 개의 앱 연결",
    "휴대폰, 데스크톱 어떤 브라우저에서도 사용",
  ],
  cta: "무료 라이트닝 주소 받기",
};

const hi: RizfulPitchStrings = {
  free: "मुफ़्त",
  headline: "Rizful आपका मुफ़्त Lightning होमबेस है",
  subhead: "कोई इंस्टॉल नहीं, कोई सब्सक्रिप्शन नहीं, पैसे पाने पर कोई शुल्क नहीं।",
  features: [
    "आपका अपना @rizful.com Lightning Address",
    "Bitcoin भुगतान प्राप्त करें",
    "भुगतान लगभग एक सेकंड में पूरा",
    "NWC से सैकड़ों ऐप्स जोड़ें",
    "फ़ोन या कंप्यूटर, किसी भी ब्राउज़र में चलता है",
  ],
  cta: "अपना मुफ़्त Lightning Address पाएं",
};

const tr: RizfulPitchStrings = {
  free: "ÜCRETSİZ",
  headline: "Rizful ücretsiz Lightning üssünüzdür",
  subhead: "Kurulum yok, abonelik yok, almak için ücret yok.",
  features: [
    "Size özel @rizful.com Lightning Adresi",
    "Bitcoin ödemeleri alın",
    "Ödemeler yaklaşık bir saniyede tamamlanır",
    "NWC ile yüzlerce uygulamaya bağlanın",
    "Telefon ya da bilgisayar, her tarayıcıda çalışır",
  ],
  cta: "Ücretsiz Lightning Adresinizi alın",
};

const ru: RizfulPitchStrings = {
  free: "БЕСПЛАТНО",
  headline: "Rizful — ваша бесплатная база для Lightning",
  subhead: "Без установки, без подписки, без комиссии за получение.",
  features: [
    "Собственный Lightning-адрес @rizful.com",
    "Получение платежей в биткоинах",
    "Платежи проходят примерно за секунду",
    "Сотни приложений через NWC",
    "Работает в любом браузере, на телефоне и компьютере",
  ],
  cta: "Получить бесплатный Lightning-адрес",
};

const ar: RizfulPitchStrings = {
  free: "مجاني",
  headline: "Rizful هو مقرّك المجاني لشبكة Lightning",
  subhead: "بدون تثبيت، بدون اشتراك، بدون رسوم على الاستلام.",
  features: [
    "عنوان Lightning خاص بك على ‎@rizful.com",
    "استلام مدفوعات البيتكوين",
    "تتم المدفوعات في حوالي ثانية",
    "اربط مئات التطبيقات عبر NWC",
    "يعمل في أي متصفح، على الهاتف أو الكمبيوتر",
  ],
  cta: "احصل على عنوان Lightning مجاني",
};

const th: RizfulPitchStrings = {
  free: "ฟรี",
  headline: "Rizful คือฐาน Lightning ฟรีของคุณ",
  subhead: "ไม่ต้องติดตั้ง ไม่ต้องสมัครสมาชิก ไม่มีค่าธรรมเนียมการรับเงิน",
  features: [
    "Lightning Address @rizful.com ของคุณเอง",
    "รับการชำระเงินด้วย Bitcoin",
    "ชำระเงินเสร็จในประมาณหนึ่งวินาที",
    "เชื่อมต่อแอปนับร้อยด้วย NWC",
    "ใช้ได้ทุกเบราว์เซอร์ ทั้งมือถือและคอมพิวเตอร์",
  ],
  cta: "รับ Lightning Address ฟรี",
};

const pl: RizfulPitchStrings = {
  free: "ZA DARMO",
  headline: "Rizful to Twoja darmowa baza Lightning",
  subhead: "Bez instalacji, bez subskrypcji, bez opłat za odbiór.",
  features: [
    "Własny adres Lightning @rizful.com",
    "Odbieraj płatności w Bitcoinie",
    "Płatności rozliczane w około sekundę",
    "Połącz setki aplikacji przez NWC",
    "Działa w każdej przeglądarce, na telefonie i komputerze",
  ],
  cta: "Odbierz darmowy adres Lightning",
};

const uk: RizfulPitchStrings = {
  free: "БЕЗКОШТОВНО",
  headline: "Rizful — ваша безкоштовна база для Lightning",
  subhead: "Без встановлення, без підписки, без комісії за отримання.",
  features: [
    "Власна Lightning-адреса @rizful.com",
    "Отримання платежів у біткоїнах",
    "Платежі проходять приблизно за секунду",
    "Сотні застосунків через NWC",
    "Працює в будь-якому браузері, на телефоні й комп'ютері",
  ],
  cta: "Отримати безкоштовну Lightning-адресу",
};

const id: RizfulPitchStrings = {
  free: "GRATIS",
  headline: "Rizful adalah markas Lightning gratis Anda",
  subhead: "Tanpa instalasi, tanpa langganan, tanpa biaya untuk menerima.",
  features: [
    "Lightning Address @rizful.com milik Anda sendiri",
    "Terima pembayaran Bitcoin",
    "Pembayaran selesai dalam sekitar satu detik",
    "Hubungkan ratusan aplikasi dengan NWC",
    "Berjalan di browser apa pun, ponsel atau komputer",
  ],
  cta: "Dapatkan Lightning Address gratis",
};

const vi: RizfulPitchStrings = {
  free: "MIỄN PHÍ",
  headline: "Rizful là căn cứ Lightning miễn phí của bạn",
  subhead: "Không cần cài đặt, không đăng ký gói, không phí nhận tiền.",
  features: [
    "Lightning Address @rizful.com của riêng bạn",
    "Nhận thanh toán Bitcoin",
    "Thanh toán hoàn tất trong khoảng một giây",
    "Kết nối hàng trăm ứng dụng qua NWC",
    "Chạy trên mọi trình duyệt, điện thoại hay máy tính",
  ],
  cta: "Nhận Lightning Address miễn phí",
};

const bn: RizfulPitchStrings = {
  free: "ফ্রি",
  headline: "Rizful আপনার ফ্রি Lightning হোমবেস",
  subhead: "ইনস্টল নেই, সাবস্ক্রিপশন নেই, টাকা পেতে কোনো ফি নেই।",
  features: [
    "আপনার নিজের @rizful.com Lightning Address",
    "Bitcoin পেমেন্ট গ্রহণ করুন",
    "প্রায় এক সেকেন্ডে পেমেন্ট সম্পন্ন",
    "NWC দিয়ে শত শত অ্যাপ যুক্ত করুন",
    "ফোন বা কম্পিউটার, যেকোনো ব্রাউজারে চলে",
  ],
  cta: "আপনার ফ্রি Lightning Address নিন",
};

const ms: RizfulPitchStrings = {
  free: "PERCUMA",
  headline: "Rizful ialah pangkalan Lightning percuma anda",
  subhead: "Tiada pemasangan, tiada langganan, tiada caj untuk menerima.",
  features: [
    "Lightning Address @rizful.com anda sendiri",
    "Terima bayaran Bitcoin",
    "Bayaran selesai dalam kira-kira satu saat",
    "Sambungkan ratusan aplikasi dengan NWC",
    "Berfungsi di mana-mana pelayar, telefon atau komputer",
  ],
  cta: "Dapatkan Lightning Address percuma",
};

const ka: RizfulPitchStrings = {
  free: "უფასო",
  headline: "Rizful თქვენი უფასო Lightning ბაზაა",
  subhead: "ინსტალაციის, გამოწერისა და მიღების საკომისიოს გარეშე.",
  features: [
    "თქვენი საკუთარი @rizful.com Lightning მისამართი",
    "Bitcoin გადახდების მიღება",
    "გადახდები დაახლოებით ერთ წამში სრულდება",
    "ასობით აპის დაკავშირება NWC-ით",
    "მუშაობს ნებისმიერ ბრაუზერში, ტელეფონსა თუ კომპიუტერზე",
  ],
  cta: "მიიღეთ უფასო Lightning მისამართი",
};

const PITCH_STRINGS: Record<string, RizfulPitchStrings> = {
  en, es, pt, fr, de, it, nl, ja, zh, ko, hi, tr, ru, ar, th, pl, uk, id, vi, bn, ms, ka,
};

export function getPitchStrings(locale?: string): RizfulPitchStrings {
  return (locale && PITCH_STRINGS[locale]) || en;
}
